import { getAxiosClient } from "../../HttpsService";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { CustomDataType, DataType } from "./customDataTypes-interface";

export const fetchCustomDataTypesByApplication = createAsyncThunk(
  "customDataTypes/fetchCustomDataTypesByApplication",
  async (appUuid: string) => {
    const client = getAxiosClient();
    const response = await client.get(
      `api/custom-data-types/app-uuid/${appUuid}`
    );
    return response.data as CustomDataType[];
  }
);

export const fetchCustomDataTypes = createAsyncThunk(
  "customDataTypes/fetchCustomDataTypes",
  async () => {
    const client = getAxiosClient();
    const response = await client.get(`api/custom-data-types`);
    return response.data as CustomDataType[];
  }
);

export const fetchCustomDataTypeById = createAsyncThunk(
  "customDataTypes/fetchCustomDataTypesById",
  async (cdtId: string) => {
    const client = getAxiosClient();
    const response = await client.get(`api/custom-data-types/${cdtId}`);
    return response.data as CustomDataType;
  }
);

export const fetchDataTypes = createAsyncThunk(
  "customDataTypes/fetchDataTypes",
  async () => {
    const client = getAxiosClient();
    const response = await client.get(`api/eza_app_data_type`);
    return response.data as DataType[];
  }
);
